export default "__VITE_ASSET__511b7030__"